module.exports = __webpack_public_path__ + "static/media/m_beard_tailored_long__square_vector.f705ee4e.svg";